const ONESIGNAL_API_KEY = process.env.REACT_APP_ONESIGNAL_API_KEY;
const ONESIGNAL_APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID;

export const sendNotification = async ({ title, description, imageUrl, type, url, web_url }) => {
  try {
    const limit = 200; // Limite par page
    let allPlayers = [];

    // Première requête pour obtenir le nombre total d'utilisateurs
    const initialResponse = await fetch(
      `https://onesignal.com/api/v1/players?app_id=${ONESIGNAL_APP_ID}&limit=1&offset=0`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${ONESIGNAL_API_KEY}`,
          'Accept': 'application/json'
        }
      }
    );

    const initialData = await initialResponse.json();
    const totalCount = initialData.total_count || 0;

    // Récupérer toutes les pages avec pagination
    let currentOffset = 0;
    while (currentOffset < totalCount) {
      const response = await fetch(
        `https://onesignal.com/api/v1/players?app_id=${ONESIGNAL_APP_ID}&limit=${limit}&offset=${currentOffset}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Basic ${ONESIGNAL_API_KEY}`,
            'Accept': 'application/json'
          }
        }
      );

      const data = await response.json();

      if (data.players && data.players.length > 0) {
        allPlayers = [...allPlayers, ...data.players];
      }

      currentOffset += limit;

      // Petit délai entre chaque requête pour éviter les limitations de taux
      if (currentOffset < totalCount) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }

    // Filtrer les utilisateurs valides (non invalidés)
    const subscribedPlayerIds = allPlayers
      .filter(player => player.invalid_identifier !== true)
      .map(player => player.id);

    const response = await fetch('https://onesignal.com/api/v1/notifications', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${ONESIGNAL_API_KEY}`,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        app_id: ONESIGNAL_APP_ID,
        include_player_ids: subscribedPlayerIds,
        contents: {
          en: description,
          fr: description
        },
        headings: {
          en: title,
          fr: title
        },
        chrome_web_image: imageUrl,
        ios_attachments: {
          id1: imageUrl
        },
        ios_sound: "default",
        ios_badgeType: "Increase",
        ios_badgeCount: 1,
        priority: 10,
        // ✅ Ajout de la route dans les données supplémentaires
        data: {
          route: type === 'news' ? '/news' : type === 'deal' ? '/deals' : type === 'loyalty' ? '/fidelite' : null
        },
        web_url: url,
        
      })
    });

    return await response.json();

  } catch (error) {
    throw error;
  }
}; 